export default __webpack_public_path__ + "static/media/kas.9c325e35.png";